import * as React from 'react';
import { SVGProps } from 'react';

const SvgProgressArrows2 = (props: SVGProps<SVGSVGElement>) => (
  <svg width={14} height={18} viewBox="0 0 14 18" fill="none" role="img" {...props}>
    <path
      d="M13.3 8.977c0-1.67-.52-2.912-1.736-4.152a.829.829 0 0 0-1.187 0 .87.87 0 0 0 0 1.213c.906.924 1.243 1.72 1.243 2.939 0 1.259-.48 2.443-1.353 3.332-.844.86-1.746 1.288-2.88 1.366l1.047-1.069a.869.869 0 0 0 0-1.212.827.827 0 0 0-1.188 0l-3.114 3.177 3.114 3.178a.83.83 0 0 0 1.188 0 .869.869 0 0 0 0-1.212L7.31 15.392c1.615-.07 2.975-.68 4.143-1.87A6.45 6.45 0 0 0 13.3 8.977ZM2.38 9c0-1.26.48-2.443 1.353-3.333.848-.865 1.757-1.293 2.904-1.367l-1.07 1.093a.869.869 0 0 0 0 1.212.827.827 0 0 0 1.187.001l3.114-3.177L6.754.25a.827.827 0 0 0-1.188 0 .869.869 0 0 0 0 1.212l1.101 1.124c-1.607.074-2.96.682-4.122 1.868A6.45 6.45 0 0 0 .7 9c0 1.67.52 2.912 1.735 4.152a.829.829 0 0 0 1.188 0 .87.87 0 0 0 0-1.214C2.717 11.015 2.38 10.218 2.38 9Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgProgressArrows2;
